import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import WizardButtons from './../../wizard/navigator/buttons';
import Modal from '../../modal';

class ConfirmationDialog extends React.Component {
    render() {
        const { modal, message, onClose, onSubmit, handleSubmit, submitting, save } = this.props;

        return (
            <Modal open={modal.open} onClose={onClose} managedClose size="col-xs-12 col-sm-6 col-sm-offset-3">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                        <div className="col-xs-12 text-center">
                            <h4>{message || <FormattedMessage {...messages.confirmation} />}</h4>
                        </div>
                    </div>
                    <WizardButtons
                        disabled={submitting}
                        back={{ action: onClose, message: <FormattedMessage {...messages.cancel} /> }}
                        submit={save ? { show: false } : { message: <FormattedMessage {...messages.confirm} /> }}
                        save={save}
                    />
                </form>
            </Modal>
        );
    }
}

ConfirmationDialog.defaultProps = {
    modal: undefined,
    message: undefined,
    onClose: undefined,
    onSubmit: undefined
};
ConfirmationDialog.propTypes = {
    modal: PropTypes.object.isRequired,
    message: PropTypes.any,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
};

export default reduxForm({
    form: 'confirmation-dialog',
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    forceUnregisterOnUnmount: false
})(ConfirmationDialog);



// WEBPACK FOOTER //
// ./src/components/dialogs/confirmation/index.jsx